import { u } from "umbrellajs";

u(".js-navigation-toggle").on("click", ({ currentTarget }) => {
  u(u(currentTarget).data("target")).toggleClass("navigation-open");
  u(currentTarget).toggleClass("is-active");
});
